// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trial-balance-container {
  background: transparent;
  border-radius: 0;
  padding: 30px;
  box-shadow: none;
  margin-top: 0;
}

.trial-balance-container h2 {
  color: #333;
  margin-bottom: 25px;
  font-size: 1.8rem;
}

.refresh-btn {
  margin-bottom: 20px;
  padding: 10px 20px;
  font-size: 1rem;
}

.loading-spinner {
  text-align: center;
  padding: 40px;
  font-size: 1.2rem;
  color: #667eea;
}

.key-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.metric-card {
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.2s;
}

.metric-card:hover {
  transform: translateY(-5px);
}

.debit-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.credit-card {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
}

.balance-card.balanced {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  color: white;
}

.balance-card.unbalanced {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  color: white;
}

.metric-label {
  font-size: 0.9rem;
  opacity: 0.9;
  margin-bottom: 10px;
  font-weight: 500;
}

.metric-value {
  font-size: 1.8rem;
  font-weight: bold;
}

.tb-report {
  margin-top: 30px;
}

.report-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  border-radius: 8px 8px 0 0;
  margin-bottom: 20px;
}

.report-header h3 {
  margin: 0 0 15px 0;
  font-size: 1.5rem;
}

.report-info {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.report-info p {
  margin: 5px 0;
  font-size: 0.95rem;
}

.tb-report-table {
  margin-top: 20px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  background: white;
}

.tb-table-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 10px;
  padding: 15px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: bold;
  font-size: 1rem;
}

.tb-header-cell {
  padding: 5px;
}

.tb-header-cell.account-name {
  text-align: left;
}

.tb-header-cell.debit-amount,
.tb-header-cell.credit-amount {
  text-align: right;
}

.tb-table-body {
  background: white;
}

.tb-account-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 10px;
  padding: 12px 20px;
  border-bottom: 1px solid #e9ecef;
  transition: background-color 0.2s;
}

.tb-account-row:hover {
  background-color: #f8f9fa;
}

.tb-account-cell {
  padding: 5px;
}

.tb-account-cell.account-name {
  font-weight: 500;
  color: #333;
  text-align: left;
}

.tb-account-cell.debit-amount,
.tb-account-cell.credit-amount {
  text-align: right;
  color: #495057;
  font-family: 'Courier New', monospace;
}

.tb-summary-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 10px;
  padding: 15px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-top: 3px solid #667eea;
  border-bottom: 3px solid #667eea;
  font-weight: bold;
  margin-top: 10px;
}

.tb-summary-cell {
  padding: 5px;
}

.tb-summary-cell.account-name {
  text-align: left;
  color: #667eea;
  font-size: 1.1rem;
}

.tb-summary-cell.debit-amount,
.tb-summary-cell.credit-amount {
  text-align: right;
  color: #667eea;
  font-size: 1.1rem;
  font-family: 'Courier New', monospace;
}

.error-message {
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  color: #c33;
  display: flex;
  align-items: center;
  gap: 10px;
}

.error-icon {
  font-size: 1.5rem;
}

@media (max-width: 768px) {
  .report-columns,
  .row-data,
  .row-summary {
    grid-template-columns: 1fr;
  }

  .col-data.amount,
  .summary-col {
    text-align: left;
  }

  .key-metrics {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TrialBalance.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".trial-balance-container {\n  background: transparent;\n  border-radius: 0;\n  padding: 30px;\n  box-shadow: none;\n  margin-top: 0;\n}\n\n.trial-balance-container h2 {\n  color: #333;\n  margin-bottom: 25px;\n  font-size: 1.8rem;\n}\n\n.refresh-btn {\n  margin-bottom: 20px;\n  padding: 10px 20px;\n  font-size: 1rem;\n}\n\n.loading-spinner {\n  text-align: center;\n  padding: 40px;\n  font-size: 1.2rem;\n  color: #667eea;\n}\n\n.key-metrics {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.metric-card {\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  transition: transform 0.2s;\n}\n\n.metric-card:hover {\n  transform: translateY(-5px);\n}\n\n.debit-card {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.credit-card {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  color: white;\n}\n\n.balance-card.balanced {\n  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);\n  color: white;\n}\n\n.balance-card.unbalanced {\n  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);\n  color: white;\n}\n\n.metric-label {\n  font-size: 0.9rem;\n  opacity: 0.9;\n  margin-bottom: 10px;\n  font-weight: 500;\n}\n\n.metric-value {\n  font-size: 1.8rem;\n  font-weight: bold;\n}\n\n.tb-report {\n  margin-top: 30px;\n}\n\n.report-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 20px;\n  border-radius: 8px 8px 0 0;\n  margin-bottom: 20px;\n}\n\n.report-header h3 {\n  margin: 0 0 15px 0;\n  font-size: 1.5rem;\n}\n\n.report-info {\n  display: flex;\n  gap: 30px;\n  flex-wrap: wrap;\n}\n\n.report-info p {\n  margin: 5px 0;\n  font-size: 0.95rem;\n}\n\n.tb-report-table {\n  margin-top: 20px;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  overflow: hidden;\n  background: white;\n}\n\n.tb-table-header {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  gap: 10px;\n  padding: 15px 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  font-weight: bold;\n  font-size: 1rem;\n}\n\n.tb-header-cell {\n  padding: 5px;\n}\n\n.tb-header-cell.account-name {\n  text-align: left;\n}\n\n.tb-header-cell.debit-amount,\n.tb-header-cell.credit-amount {\n  text-align: right;\n}\n\n.tb-table-body {\n  background: white;\n}\n\n.tb-account-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  gap: 10px;\n  padding: 12px 20px;\n  border-bottom: 1px solid #e9ecef;\n  transition: background-color 0.2s;\n}\n\n.tb-account-row:hover {\n  background-color: #f8f9fa;\n}\n\n.tb-account-cell {\n  padding: 5px;\n}\n\n.tb-account-cell.account-name {\n  font-weight: 500;\n  color: #333;\n  text-align: left;\n}\n\n.tb-account-cell.debit-amount,\n.tb-account-cell.credit-amount {\n  text-align: right;\n  color: #495057;\n  font-family: 'Courier New', monospace;\n}\n\n.tb-summary-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  gap: 10px;\n  padding: 15px 20px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-top: 3px solid #667eea;\n  border-bottom: 3px solid #667eea;\n  font-weight: bold;\n  margin-top: 10px;\n}\n\n.tb-summary-cell {\n  padding: 5px;\n}\n\n.tb-summary-cell.account-name {\n  text-align: left;\n  color: #667eea;\n  font-size: 1.1rem;\n}\n\n.tb-summary-cell.debit-amount,\n.tb-summary-cell.credit-amount {\n  text-align: right;\n  color: #667eea;\n  font-size: 1.1rem;\n  font-family: 'Courier New', monospace;\n}\n\n.error-message {\n  background: #fee;\n  border: 1px solid #fcc;\n  border-radius: 8px;\n  padding: 15px;\n  margin: 20px 0;\n  color: #c33;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.error-icon {\n  font-size: 1.5rem;\n}\n\n@media (max-width: 768px) {\n  .report-columns,\n  .row-data,\n  .row-summary {\n    grid-template-columns: 1fr;\n  }\n\n  .col-data.amount,\n  .summary-col {\n    text-align: left;\n  }\n\n  .key-metrics {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
